const FULL_SCREEN_MODE = 'fullScreenMode'
const WINDOWED_MODE = 'windowedMode'
const EDIT_MODE = 'editMode'
const SELECT_NEXT_SLIDE = 'selectNextSlide'
const SELECT_PREV_SLIDE = 'selectPrevSlide'
const SET_CURRENT_ACTIVE_SLIDE = 'setCurrentActiveSlide'
const SET_CURRENT_SLIDE_MODE = 'setCurrentSlideMode'

export {
  FULL_SCREEN_MODE,
  WINDOWED_MODE,
  EDIT_MODE,
  SET_CURRENT_SLIDE_MODE,
  SELECT_NEXT_SLIDE,
  SELECT_PREV_SLIDE,
  SET_CURRENT_ACTIVE_SLIDE,
}
